import { constantsTypes } from '../reduxConstants'

export const setCityChangeData = (value) => {
  return {
    type: constantsTypes.CITY_CHANGE,
    value: value,
  }
}